<template>
    <el-tooltip placement="top" :content="computedContent" effect="light" :open-delay="300">
        <span :class="computedClass" style="margin-top: 4px;"><i :class="computedIcon" aria-hidden="true"></i></span>
    </el-tooltip>
</template>

<script>
import Vue from "vue";
export default Vue.component("pcr-user-state", {
  props: {
    item: {
      default: ""
    }
  },
  computed: {
    computedClass() {
      return this.item.RegistrationDate != null
        ? "pull-right text-success"
        : "pull-right text-warning";
    },
    computedIcon() {
      return this.item.RegistrationDate != null
        ? "fa fa-check-circle-o"
        : "fa fa-clock-o";
    },
    computedContent() {
      return this.item.RegistrationDate != null
        ? "Inscription validée"
        : "Inscription en attente";
    }
  },
  methods: {}
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/visual/pcr-user-state.vue